import gql from 'graphql-tag';

export const registerInspectionPhotoMutation = gql`
  mutation RegisterInspectionPhoto($input: RegisterInspectionPhotoInput!) {
    registerInspectionPhoto(input: $input) {
      success
      newVersion
    }
  }
`;
